export default __webpack_public_path__ + "static/speedup-general-fb713a1146f052cda804ffaeebdd8be0.svg";